require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ecole-centrale-de-lille-2-5-2-1.json") })
        }
      }, "path---ecole-centrale-de-lille-2-5-2-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ecole-centrale-de-lille-2-5-2-1!./.cache/json/ecole-centrale-de-lille-2-5-2-1.json
// module id = 401
// module chunks = 231608221292675